import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { WebsiteTitleService } from '@core/services/website-title.service';
import { StatesService } from '@core/store/states.service';
import { NzIconService } from 'ng-zorro-antd/icon';
import {
  NzContentComponent,
  NzFooterComponent,
  NzHeaderComponent,
  NzLayoutComponent,
} from 'ng-zorro-antd/layout';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { WaterMarkService } from 'src/app/core/services/watermark.service';
import { DemoBannerComponent } from './core/components/demo-banner/demo-banner.component';
import { DemoCursorComponent } from './core/components/demo-cursor/demo-cursor.component';
import { DemoExportPreviewComponent } from './core/components/demo-export-preview/demo-export-preview.component';
import { DemoLoginModalComponent } from './core/components/demo-login-modal/demo-login-modal.component';
import { NavigationService } from './core/services/navigation.service';
import { MainFooterComponent } from './shared/components/main-footer/main-footer.component';
import { MainHeaderComponent } from './shared/components/main-header/main-header.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  imports: [
    NzLayoutComponent,
    NzContentComponent,
    NzHeaderComponent,
    MainHeaderComponent,
    RouterOutlet,
    NzFooterComponent,
    MainFooterComponent,
    NzSpinComponent,
    DemoLoginModalComponent,
    DemoBannerComponent,
    DemoCursorComponent,
    DemoExportPreviewComponent,
  ],
})
export class AppComponent implements OnInit {
  private ws = inject(WaterMarkService);
  private navigationService = inject(NavigationService);
  private router = inject(Router);
  private statesService = inject(StatesService);
  WebSiteTitleService = inject(WebsiteTitleService);

  show = false;
  demoLoginRequired = this.statesService.demoLoginRequired$.getValue();
  // APP_INITIALIZER 里已经 await 过 authorizationInit()，所以这里 getValue() 拿到的是终值
  isDemo = this.statesService.environmentInfo$.getValue()?.demo === true;

  constructor() {
    const iconService = inject(NzIconService);

    this.ws.watermarkInit();
    iconService.changeAssetsSource(
      'https://linkworld-cdn.linkworld.cn/leafpoda/optimize/'
    );
    // 监听路由变化
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (!event.url.includes('promotion')) {
          this.navigationService.clearHistory();
        }
      }
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.show = true;
    }, 500);
  }

  reloadPage(): void {
    window.location.reload();
  }
}
